import { Directive, Input, HostBinding } from '@angular/core';
import { BaseDirective } from '../base/_base.directive';

@Directive({
  selector: '[removeIcon]',
  exportAs: 'remove-icon'
})
export class RemoveIconDirective extends BaseDirective {

  @HostBinding('class.icon') iconClass: boolean = true;

  @Input() set color(color: string) {
    this.setClassName((<any>this._colorsMap)[color]);
  }

  private _colorsMap: any = {
    red: 'close-red-icon',
    white: 'close-white-icon',
    black: 'close-black-icon',
    grey: 'close-grey-icon'
  };

}
